import { Paper, LoadingOverlay, Group, Text, Button, Table, Badge, ActionIcon } from '@mantine/core';
import { IconPlus, IconEdit, IconTrash } from '@tabler/icons-react';

export default function ContactsSettingsSection({
  loading,
  activeTab,
  contacts,
  fetchContacts,
  openNewContact,
  openEditContact,
  handleDeleteContact,
}) {
  return (
    <Paper withBorder p="md" radius="md" mt="xs" pos="relative">
      <LoadingOverlay visible={loading && activeTab === 'contacts'} overlayProps={{ radius: 'sm', blur: 2 }} />

      <Group justify="space-between" mb="md">
        <Text fw={700}>Kurumsal Rehber Yönetimi</Text>
        <Group>
          <Button size="xs" variant="light" onClick={fetchContacts}>Yenile</Button>
          <Button size="xs" color="cyan" leftSection={<IconPlus size={14} />} onClick={openNewContact}>
            Yeni Kişi Ekle
          </Button>
        </Group>
      </Group>

      <Table striped highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Ad Soyad</Table.Th>
            <Table.Th>Ünvan / Departman</Table.Th>
            <Table.Th>Dahili</Table.Th>
            <Table.Th>Mobil</Table.Th>
            <Table.Th style={{ textAlign: 'right' }}>İşlem</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {contacts.map((contact) => (
            <Table.Tr key={contact.id}>
              <Table.Td fw={500}>{contact.name}</Table.Td>
              <Table.Td>{contact.title || '-'}</Table.Td>
              <Table.Td><Badge color="cyan" variant="light">{contact.ext}</Badge></Table.Td>
              <Table.Td>{contact.mobile || '-'}</Table.Td>
              <Table.Td style={{ textAlign: 'right' }}>
                <Group gap="xs" justify="flex-end">
                  <ActionIcon color="blue" variant="subtle" onClick={() => openEditContact(contact)}>
                    <IconEdit size={16} />
                  </ActionIcon>
                  <ActionIcon color="red" variant="subtle" onClick={() => handleDeleteContact(contact.id)}>
                    <IconTrash size={16} />
                  </ActionIcon>
                </Group>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}